import { PromoRenderer } from '@ps-int/promozavr/app/PromoRenderer';
import PSHeader from '@ps-int/ps-header/src';
import { GlobalBar } from '@yandex-360/global-bar';

export enum ModuleFederationComponents {
    PSHeader = 'PSHeader',
    GlobalBar = 'GlobalBar',
    PromoRenderer = 'PromoRenderer',
}

export const FALLBACK_INIT_COMPONENTS = [
    ModuleFederationComponents.PSHeader,
    ModuleFederationComponents.GlobalBar,
    ModuleFederationComponents.PromoRenderer,
];

export const FALLBACK_COMPONENTS = {
    [ModuleFederationComponents.PSHeader]: { default: PSHeader },
    [ModuleFederationComponents.GlobalBar]: { GlobalBar: GlobalBar },
    [ModuleFederationComponents.PromoRenderer]: {
        default: PromoRenderer,
    },
};

export const LOAD_COMPONENT_TIMEOUT = 1000;
